import React, { Component } from 'react'
import { connect } from 'react-redux'

import { paymentComparisonToggleChartDataTable } from './actions'

const mapStateToProps = (state, hocProps) => ({
    showChartDataTable: state.getIn([
        'ui',
        'workspace',
        'report',
        hocProps?.id,
        'blocks',
        'paymentComparison',
        'customData',
        'showChartDataTable',
    ]),
})

export default function (InnerComponent) {
    @connect(mapStateToProps, { paymentComparisonToggleChartDataTable })
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }
    return HocConnect
}
